<template>
  <div
    v-if="active"
    class="animate-spin inline-block border-2 border-r-transparent rounded-full border-primary-main w-6 h-6"
    role="status"
  ></div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
